// CSV de un corte para la nómina de la cadena: el archivo que arma el motor, con sus avisos dentro.
import { useState } from 'react';
import { toast } from 'sonner';
import { CommissionPayoutStatusEnum } from '@fiado/type-kit/bin/retailCommission/enums/CommissionPayoutStatusEnum';
import { userMessageOf } from '@/api/errors';
import { Button, Modal, Skeleton } from '@/kit';
import { useExportPayout, usePayouts } from '../../api/commissionQueries';
import { downloadEngineCsv } from '../../lib/engineCsv';
import { weekLabel } from '../../lib/payoutPeriods';
import { FIELD, LABEL } from '../fieldStyles';

export function ExportCsvModal({ onClose }: { onClose: () => void }) {
    const payouts = usePayouts(12);
    const exporter = useExportPayout();
    const [periodId, setPeriodId] = useState('');
    // Solo cortes cerrados: uno abierto todavía no tiene el desglose que paga la nómina.
    const list = (payouts.data?.payouts ?? [])
        .filter((payout) => payout.status === CommissionPayoutStatusEnum.CLOSED)
        .sort((a, b) => b.periodId.localeCompare(a.periodId));
    const chosen = periodId !== '' ? periodId : (list.at(0)?.periodId ?? '');

    const download = () => {
        exporter.mutate(chosen, {
            onSuccess: (file) => {
                downloadEngineCsv(file);
                onClose();
            },
            onError: (error) => {
                toast.error(userMessageOf(error));
            },
        });
    };

    return (
        <Modal isOpen onClose={onClose} title="Exportar CSV del corte" size="sm">
            {payouts.isLoading ? (
                <Skeleton lines={2} />
            ) : list.length === 0 ? (
                <p className="text-[12px] text-muted-foreground">Todavía no hay cortes cerrados.</p>
            ) : (
                <div className="flex flex-col gap-3">
                    <div>
                        <label htmlFor="csv-period" className={LABEL}>
                            Corte
                        </label>
                        <select
                            id="csv-period"
                            className={FIELD}
                            value={chosen}
                            onChange={(event) => {
                                setPeriodId(event.target.value);
                            }}
                        >
                            {list.map((payout) => (
                                <option key={payout.periodId} value={payout.periodId}>
                                    {weekLabel(payout.periodId)}
                                </option>
                            ))}
                        </select>
                    </div>
                    <p className="text-[10.5px] text-muted-foreground">
                        Una fila por vendedor con su neto, y los avisos de lo que el corte no paga.
                    </p>
                    <div className="flex justify-end gap-2">
                        <Button variant="outline" onClick={onClose}>
                            Cancelar
                        </Button>
                        <Button
                            onClick={download}
                            disabled={chosen === ''}
                            isLoading={exporter.isPending}
                        >
                            Descargar
                        </Button>
                    </div>
                </div>
            )}
        </Modal>
    );
}
